import React from 'react';
import moment from 'moment';

interface StatusCircleProps {
  dataInicial: Date;
  dataFormatada: string;
}

export const StatusCircle = ({ dataInicial, dataFormatada }: StatusCircleProps) => {
  const backgroundColorResult = moment(dataInicial).diff(moment(), 'days') <= 0 ? '#EE4E4E' : '#0D5A9A';
  return (
    (dataInicial ? (
      <>
        <div className="status-circle">
          <span
            style={{
              content: ' ',
              borderRadius: '50%',
              width: '10px',
              height: '10px',
              backgroundColor: backgroundColorResult,
              display: 'inline-block',
              padding: '5px',
            }}></span>
          <span
            style={{
              padding: '5px',
            }}>
            {dataFormatada}
          </span>
        </div>

      </>) : (<> </>))
  );
};